import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import Box from '@mui/material/Box';

import {
  StyledBorder,
  StyledAbsoluteContainer
} from 'bento-ordering/group_ordering/ui_components/CartGroupOrder';
import AdminItems from 'bento-ordering/group_ordering/components/AdminItems';
import GuestsItems from 'bento-ordering/group_ordering/components/GuestsItems';

const CartGroupOrderItemsContainer = ({
  getEditCartItemPath,
  removeItemFromCart,
  handleEditClick,
  currentCartPath,
  adminDiner = {},
  guestDiners = []
}) => {
  return (
    <>
      {!isEmpty(adminDiner) && (
        <AdminItems
          adminDiner={adminDiner}
          getEditCartItemPath={getEditCartItemPath}
          removeItemFromCart={removeItemFromCart}
          handleEditClick={handleEditClick}
          currentCartPath={currentCartPath}
        />
      )}
      <GuestsItems
        guestDiners={guestDiners}
        adminDiner={adminDiner}
        getEditCartItemPath={getEditCartItemPath}
        removeItemFromCart={removeItemFromCart}
        handleEditClick={handleEditClick}
        currentCartPath={currentCartPath}
      />
      <Box position="relative" height="16px" display="flex" alignItems="end">
        <StyledAbsoluteContainer>
          <StyledBorder flexGrow={1} />
        </StyledAbsoluteContainer>
      </Box>
    </>
  );
};

CartGroupOrderItemsContainer.propTypes = {
  getEditCartItemPath: PropTypes.func,
  removeItemFromCart: PropTypes.func,
  handleEditClick: PropTypes.func,
  currentCartPath: PropTypes.string,
  adminDiner: PropTypes.object,
  guestDiners: PropTypes.array
};

export default CartGroupOrderItemsContainer;
